import React, { Component } from 'react';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host, api_auth} from '../../../../../common/globals/constants';
import writeXlsxFile from 'write-excel-file/browser';
import { buildExcelRowsFromObjects, withExcelTitleRow, buildObjectiveTitle } from '../../../../../utils/fns/build-excel-rows';
import { MaterialTableExportAction } from '../../../../../components/MaterialTableExportAction';
import CircularProgress from '@material-ui/core/CircularProgress';
// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Popover from '@material-ui/core/Popover';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';

import moment from 'moment'
import 'moment/locale/es'  
import compose from 'recompose/compose';
import { useTranslation, withTranslation } from 'react-i18next';
import { reportFetchError } from '../../../../../observability/rum';
moment.locale('es')
const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
class EventsMeasurements extends Component {

    constructor(props) {
        super(props);
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,           
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            extendEl: null,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            //listObjectives: this.props.params.props.listObjectives,
            nameNodo: t('measurements.events-measurements.name-nodo'),
            nodo: 0
            //listNodo: []
        }  
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.params.period !== prevState.time) {
            
            return {
                externalData: null,
                //prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                //isStatePeriod: nextProps.params.isStatePeriod
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                externalData: null,
                //prevObjectiveId: props.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh,          
            }

        } else if ((nextProps.params.period === prevState.time) && (nextProps.params.statePeriod !== prevState.statePeriod)) {
            return {
                //prevObjectiveId: props.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isStatePeriod: nextProps.params.isStatePeriod
            }
        }
        return null;
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }

        /*if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.step !== this.state.step) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {
            this.getDataFromAPI();
        }*/

        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {                
            this.getDataFromAPI();
        }

    }
   
    

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, step, isStepDowntime } = this.props.params
        const { history } = this.props;

        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let time = 'w'
        //let stepLocal = step
        let node = 0
        if (this.state.period !== 'w') {
            time = 'd'
        }
        /*if (isStepDowntime) {
            stepLocal = -1
        }*/
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/getResultadosObjetivoEstadisticaCustom/?objetivoId=${objetivo_id}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&nodoId=${node}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('HTTP error ' + response.status);
                    }
                    return response.json();
                })
                .then(myJson => {
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            /*if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }*/
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                })
                .catch(error => {
                    reportFetchError('EventsMeasurements', error);
                    this.setState({ dataError: true, data: null, isLoading: false });
                });
        } else {
            fetch(api_host+`/reporte/online/indicadores/getResultadosObjetivoEstadistica/?objetivoId=${objetivo_id}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&t=${period}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('HTTP error ' + response.status);
                    }
                    return response.json();
                })
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            /*if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }*/
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                })
                .catch(error => {
                    reportFetchError('EventsMeasurements', error);
                    this.setState({ dataError: true, data: null, isLoading: false });
                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {
            let arrayRows = []            
            let evento = externalData.Objetivo.Eventos
            let totalMediciones = externalData.Objetivo.total_mediciones
            //this.props.params.onFirstInfo(externalData.Objetivo.Mediciones)
            if (evento.length > 0) {
                Object.keys(evento).map((key)=> {
                    let rows = {}     
                    rows['paso'] = evento[key]['id'][0]['paso_nombre']
                    rows['cantidad'] = evento[key]['cantidad']
                    rows['codigo'] = evento[key]['eventos'][0]['nombre']
                    totalMediciones.forEach(function(value){
                       
                        if (evento[key]['id'][0]['paso_nombre'] == Object.entries(value)[0][0]){
                            rows['porcentaje'] = ((evento[key]['cantidad'] / Object.entries(value)[0][1]) * 100).toFixed(2)
                        }
                    })
                                      
                    arrayRows.push(rows)        
                })  
    
                this.setState({
                    rows : arrayRows,                    
                    isLoading: false,                    
                    dataError: false,
                    //listNodo: nodos
                });
            } else {
                this.setState({                    
                    isLoading: false,
                    rows: null,                   
                    dataError: false,
                    //listNodo: nodos
                });
            }
    }
    render() {
        const { dataError, isLoading, rows } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };       
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (!dataError) {
            let periodperiodMeasurementsEvent = sessionStorage.getItem('nameMeasurementsEvento')
            sessionStorage.setItem("tableEstadisticaEvento",
                JSON.stringify(
                    {
                        'header':[
                            {'paso':t('measurements.events-measurements.table.columns.step')},
                            {'codigo':t('measurements.events-measurements.table.columns.event')},
                            {'cantidad':t('measurements.events-measurements.table.columns.total-monitoring')},
                            {'porcentaje':t('measurements.events-measurements.table.columns.percentage')}
                        ],
                        'data':rows,
                        'title':t('measurements.events-measurements.table.title'),
                        'subtitle':periodperiodMeasurementsEvent
                    }))
            return (<FormattedChart rows={rows}  isLoading={isLoading} style={style} styleHidden={styleHidden} objectiveName={buildObjectiveTitle(this.props.location.state.fromObjective)} />)
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function buildExportData(rows, t) {
    const headers = {
        paso: t('measurements.events-measurements.table.header.step'),
        codigo: t('measurements.events-measurements.table.header.event'),
        cantidad: t('measurements.events-measurements.table.header.total-monitoring'),
        porcentaje: t('measurements.events-measurements.table.header.percentage'),
    };

    return rows.map((row) => ({
        [headers.paso]: row.paso,
        [headers.codigo]: row.codigo,
        [headers.cantidad]: row.cantidad,
        [headers.porcentaje]: row.porcentaje,
    }));
}

function FormattedChart(props) {
    const { t } = useTranslation();
    return (
        <div>
            { props.rows == null  ? 
                <PortletContent>
                    <PerfectScrollbar>

                        <Typography
                        variant="h5"
                        >
                        <CircularProgress
                        variant="indeterminate"

                        size={24}
                        thickness={4}
                        
                        />
                        <br/>
                        Cargando Información...
                    </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            :
                <div style={{ maxWidth: "100%" }}>
                    <MaterialTable
                        icons={tableIcons}
                        columns={[
                            { title: t('measurements.events-measurements.table.header.step'), field: "paso"/*, defaultGroupOrder: 0*/ },
                            { title: t('measurements.events-measurements.table.header.event'), field: "codigo"/*, type: "numeric"*/ },
                            { title: t('measurements.events-measurements.table.header.total-monitoring'), field: "cantidad"/*, type: "numeric"*/},
                            { title: t('measurements.events-measurements.table.header.percentage'), field: "porcentaje"/*, type: "numeric"*/},
                        ]}
                        /*data={[
                            { monitor: "Claro (cl)", paso: "Home", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Login", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Liquidaciones", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Entel (cl)", paso: "Home", minimo: 0.280, maximo: 4.580, promedio: 2.470, uptime: 99.530, downtime: 0.470, nomon: 0.000, total: 213  }
                        ]}*/
                        data={props.rows}
                        title=" "
                        localization={t('measurements.events-measurements.table.localization', { returnObjects: true })}
                        options={{
                            grouping: true
                        }}
                        components={{
                            Action: MaterialTableExportAction
                        }}
                        actions={[
                            {
                                icon: () => <DescriptionOutlined fontSize="small" />,
                                tooltip: t('table-excel-export-button.tooltip'),
                                isFreeAction: true,
                                onClick: () => writeXlsxFile(
                                    withExcelTitleRow(
                                        props.objectiveName,
                                        buildExcelRowsFromObjects(buildExportData(props.rows, t))
                                    )
                                ).toFile(`${t('measurements.events-measurements.export-filename')}.xlsx`)
                            }
                        ]}
                    />
                </div>}
            </div>
        )

}

export default compose(withRouter, withTranslation())(EventsMeasurements);